import {Injectable} from '@angular/core';
import {CanActivate, Router} from '@angular/router';

import {AuthService} from './auth.service';
import {RoleService} from './role.service';

/** Platform diagnostics (Vision Operations): platform superuser only. */
@Injectable({
    providedIn: 'root',
})
export class OperationsAccessGuardService implements CanActivate {
    constructor(
        private auth: AuthService,
        private router: Router,
        private roleService: RoleService,
    ) {
    }

    canActivate(): boolean {
        if (!this.auth.isAuthenticated()) {
            void this.router.navigate(['/login']);
            return false;
        }

        const userInfo = this.auth.getCurrentUserInfo();
        const groups = userInfo?.role;

        if (this.roleService.canAccessVisionOperations(groups)) {
            return true;
        }

        this.router.navigate([this.roleService.getDefaultRoute(groups)]);
        return false;
    }
}
